import { useState, useEffect, useRef } from 'react'

import { RuntimeHistory } from 'types/RuntimeHistory'

import Api from 'services/api'

const useRuntimeHistory = (dealerId, deviceId, startTime, endTime, timeZone, refreshTimestamp) => {
  const [rthData, setRthData] = useState<RuntimeHistory | null>(null)
  const [isRTHDataLoaded, setIsRTHDataLoaded] = useState(false)

  const abortControllerRef = useRef(new AbortController())

  useEffect(() => {
    setIsRTHDataLoaded(false)

    const fetchRTHData = async () => {
      const abortController = new AbortController()
      const signal = abortController.signal
      abortControllerRef.current = abortController

      await Api.RuntimeHistory.get(dealerId, deviceId, startTime, endTime, timeZone, { signal }).then((res) => {
        if (!signal.aborted) {
          setRthData(res)
          setIsRTHDataLoaded(true)
        }
      }).catch(() => {
        setIsRTHDataLoaded(true)
        setRthData(null)
      })
    }

    const controller = abortControllerRef.current

    if (!controller.signal.aborted) {
      controller.abort()
    }

    fetchRTHData()

    return () => {
      controller.abort()
    }
  }, [deviceId, dealerId, startTime, endTime, timeZone, refreshTimestamp])

  return { rthData, isRTHDataLoaded, abortControllerRef }
}

export default useRuntimeHistory
